/**
 * Role utility functions for Snow Exchange
 * 
 * These functions help determine user roles consistently across the application.
 * - Operating Partner is a special variant of Resource Manager (RM)
 * - Operating Partners have access to "Freelancers I represent" section
 */

/**
 * Check if user has any RM-type role (resource_manager or operating_partner)
 * @param {Object} user - User object with role property
 * @returns {boolean}
 */
export const isRMRole = (user) => {
  if (!user?.role) return false;
  return user.role === 'resource_manager' || user.role === 'operating_partner';
};

/**
 * Check if user is specifically an Operating Partner
 * Operating Partners see "My Human Resources" and "Freelancers I represent" sections
 * @param {Object} user - User object with role property
 * @returns {boolean}
 */
export const isOperatingPartnerRole = (user) => {
  return user?.role === 'operating_partner';
};

/**
 * Check if user has PM role
 * @param {Object} user - User object with role property
 * @returns {boolean}
 */
export const isPMRole = (user) => {
  return user?.role === 'project_manager';
};

/**
 * Check if user has admin/super_admin role
 * @param {Object} user - User object with role property
 * @returns {boolean}
 */
export const isAdminRole = (user) => {
  return user?.role === 'super_admin' || user?.role === 'admin';
};

/**
 * Get display name for user role
 * @param {string} role - Role string
 * @returns {string}
 */
export const getRoleDisplayName = (role) => {
  const roleNames = {
    'resource_manager': 'Resource Manager',
    'project_manager': 'Project Manager',
    'operating_partner': 'Operating Partner',
    'super_admin': 'Administrator',
    'admin': 'Administrator'
  };
  return roleNames[role] || role;
};
